import { render, staticRenderFns } from "./roundChartMobile.vue?vue&type=template&id=640f23c1&scoped=true"
import script from "./roundChartMobile.vue?vue&type=script&lang=js"
export * from "./roundChartMobile.vue?vue&type=script&lang=js"
import style0 from "./roundChartMobile.vue?vue&type=style&index=0&id=640f23c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f23c1",
  null
  
)

export default component.exports